import styled from 'styled-components';
import React, { FC, useState } from 'react';
import { BasicInput, Checkbox, SimplePopover } from '@dev/ee-components';
import { CompressionFormat, ExportFileFormats } from '@dev/ee-api/ee-api-models';
import { useTranslation } from 'react-i18next';

import Props from './ExportProps';

const DialogContainer = styled.div`
    input {
        padding: 0;
        border: 0; //prevent 2018 styles
    }
    .MuiCheckbox-root {
        padding: 4px 9px;
    }
    .MuiInputBase-root {
        margin-bottom: 16px;
    }
`;

const fileFormatOptions = [
    {
        label: 'CSV',
        value: 'CSV',
    },
    {
        label: 'XML',
        value: 'XML',
    },
    {
        label: 'JSON',
        value: 'JSON',
    },
];

export const ExportContacts: FC<Props> = (props: Props): JSX.Element => {
    const exporteddata = props.selected;
    const { t } = useTranslation();
    const [isChecked, setIsChecked] = useState(true);

    return (
        <DialogContainer>
            <BasicInput
                id="file-name-input"
                label={t('filename')}
                defaultValue={exporteddata.fileName}
                onChange={(e): void => {
                    exporteddata.fileName = e.currentTarget.value;
                }}
            />
            <SimplePopover
                id="file-format"
                label={t('fileformat')}
                fullWidth={true}
                onItemClick={(_e, obj: Record<string, string | ExportFileFormats>): void => {
                    exporteddata.fileFormat = obj.value as ExportFileFormats;
                }}
                options={fileFormatOptions}
                type="input"
                defaultValue="CSV"
            />
            <Checkbox
                name="useZipCompresion"
                id="use-zip-compression-checkbox"
                label={t('usezipcompression')}
                checked={isChecked}
                onChange={(e, obj): void => {
                    exporteddata.compressionFormat = obj ? CompressionFormat.Zip : CompressionFormat.None;
                    setIsChecked(obj);
                }}
            />
        </DialogContainer>
    );
};
